import { combineReducers } from 'redux'
import { IGlobalMessagingState } from 'types/globalMessaging'
import globalMessagingReducer from 'utils/reducers/globalMessaging'
import { IScheduleState } from '../types/stops'
import stopsReducer from './stops'

export interface IStore {
  schedule_stops: IScheduleState
  globalMessaging: IGlobalMessagingState
}

const reducers = combineReducers({
  schedule_stops: stopsReducer,
  globalMessaging: globalMessagingReducer,
})

export default reducers
